<template>
  <div class="province-city">
    <div class="tab-wrap">
      <div class="title">商品引入状态：</div>
      <div class="item-con">
        <div
          v-for="(t, i) in inStatusList"
          :key="t.value"
          @click="handleChangeStatus(t, i)"
          :class="['tab', { active: i === selectStatusIndex }]"
        >
          {{ t.text }}
        </div>
      </div>
    </div>
    <div class="title-province">商品产地：</div>
    <el-row class="province">
      <el-col
        :span="3"
        :class="isActiveProvince(item.value) ? 'item is-active' : 'item'"
        v-for="item in options"
        :key="item.value"
        @click.native="onProvinceSelect(item)"
      >
        <div>{{ item.label }}</div>
        <div v-if="isActiveProvince(item.value)" class="is-active-bottom"></div>
      </el-col>
    </el-row>

    <el-row class="city" v-if="cityOptions.length > 0">
      <el-col
        :span="4"
        :class="isActiveCity(item.value) ? 'item is-active' : 'item'"
        v-for="item in cityOptions"
        :key="item.value"
        @click.native="onCitySelect(item)"
        >{{ item.label }}</el-col
      >
    </el-row>
  </div>
</template>

<script>
import PCAA from 'area-data/pcaa'

export default {
  name: 'ProvinceCitySelect',
  data() {
    const l0 = '86'

    const options = Object.keys(PCAA[l0]).map((l1) => {
      return {
        value: PCAA[l0][l1],
        label: PCAA[l0][l1],
        children: Object.keys(PCAA[l1]).map((l2) => {
          return {
            value: PCAA[l1][l2],
            label: PCAA[l1][l2],
            children: Object.keys(PCAA[l2]).map((l3) => {
              return {
                value: PCAA[l2][l3],
                label: PCAA[l2][l3]
              }
            })
          }
        })
      }
    })

    return {
      options: options,
      province: '',
      city: '',
      cityOptions: [],
      inStatusList: [
        {
          text: '全部',
          value: ''
        },
        {
          text: '待引入',
          value: '待引入'
        },
        {
          text: '已引入',
          value: '已引入'
        }
      ],
      selectStatusValue: '',
      selectStatusIndex: 0,
      dataList:[]
    }
  },
   computed: {
    retrieve() {
      return this.$store.state.ovop.oneVillageOneProduct.retrieve;
    }
  },
  watch:{
    retrieve(oldVal,newVal){
      this.dataList = newVal
    }
  },
  methods: {
    isActiveProvince(value) {
      return this.province == value
    },
    isActiveCity(value) {
      return this.city == value
    },
    onProvinceSelect(e) {
      console.log(e)
      this.province = e.value
      this.cityOptions = e.children

      this.$emit('change', {
        province: this.province,
        statusValue: this.selectStatusValue
      })
    },
    onCitySelect(e) {
      console.log(e)
      this.city = e.value

      this.$emit('change', {
        province: this.province,
        city: this.city,
        statusValue: this.selectStatusValue
      })
      //   this.cityOptions = e.children;
    },
    // 切换引入方式
    handleChangeStatus(t, i) {
      if(this.selectStatusValue === t.value){
        return
      }
      this.selectStatusValue = t.value
      this.selectStatusIndex = i || 0
      // if (!this.province) {
      //   return
      // }
      this.$emit('change', {
        province: this.province,
        city: this.city,
        statusValue: this.selectStatusValue
      })
    }
  }
}
</script>

<style lang="less" scoped>
.province-city {
  .province {
    margin-top: 5px;
    border: 1px solid rgba(152, 197, 167, 1);
    padding: 20px 0;
    .item {
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);

      cursor: pointer;

      height: 20px;
      margin: 10px 0;
    }

    .is-active {
      font-size: 16px;
      font-weight: 600;
      color: rgba(27, 153, 79, 1);
    }

    .is-active-bottom {
      width: 50%;
      margin: 5px auto;
      height: 2px;
      background: rgba(27, 153, 79, 1);
    }
  }

  .city {
    padding: 15px;
    background: rgba(247, 250, 248, 1);

    white-space: nowrap;

    .item {
      font-size: 14px;
      font-weight: 400;
      color: rgba(132, 135, 145, 1);
      padding: 10px 0;

      cursor: pointer;
    }

    .is-active {
      font-weight: 500;
      color: rgba(27, 153, 79, 1);
    }
  }

  .title-province {
    font-size: 16px;
    font-weight: 600;
    margin-top: 20px;
  }

  .tab-wrap {
    display: flex;
    margin-top: 20px;
    // align-items: center;
    .title {
     .title-province;
     margin-top: 0;
    }
    .item-con {
      display: flex;
      margin-left: 20px;
      cursor: pointer;
      .tab {
        margin: 0 20px;
        padding-bottom: 3px;
        &.active {
          color: #67c23a;
          border-bottom: 2px solid #67c23a;
        }
      }
    }
  }
}
</style>
